<template>
  <v-container>
    <!-- 検索エリア -->
    <v-form
      ref="searchForm"
      v-model="valid"
      lazy-validation
    >
      <v-row v-if="!solo">
        <v-col cols="4">
          <v-radio-group 
            v-model="searchCondition.attribute"
            dense
            row
            :disabled="loading"
            :readonly="solo"
            @change="search()"
          >
            <v-radio
              label="会員"
              :value="0"
              checked
            ></v-radio>
            <v-radio
              label="都道府県協会"
              :value="1"
            ></v-radio>
            <v-radio
              label="日本冷蔵倉庫協会"
              :value="2"
            ></v-radio>
          </v-radio-group>
        </v-col>
        <!-- <v-col cols="3">
          <v-radio-group 
            v-model="searchCondition.listType"
            dense
            row
            :disabled="loading"
            @change="search()"
          >
            <v-radio
              label="会員"
              :value="0"
              checked
            ></v-radio>
            <v-radio
              label="非会員"
              :value="1"
            ></v-radio>
            <v-radio
              label="閉鎖廃止"
              :value="2"
            ></v-radio>
          </v-radio-group>
        </v-col> -->
        <v-col v-if="searchCondition.attribute == 0" cols="8">
        <!-- <v-layout wrap> -->
          <v-row>
            <v-col cols="2">
            <!-- <v-checkbox 
                class="mr-3" label="会員企業" 
                v-model="searchCondition.divCompany"
                :true-value="1"   :false-value="0"
                :disabled="loading || (searchCondition.attribute != 0)"
                @change="search()"
                dense /> -->
            <v-select
                label="会員企業"
                :items="divosionCompanyList"
                dense
                v-model="searchCondition.divCompany"
                :rules="[]"
                :readonly="attribute == 1"
                :disabled="loading"
                v-on:change="search()"
            ></v-select>
          </v-col>

          <v-col cols="2">
            <!-- <v-checkbox 
                class="mr-3" label="事業所会員Ⅰ" 
                v-model="searchCondition.divIndustry1" 
                :true-value="1"   :false-value="0"
                :disabled="loading || (searchCondition.attribute != 0)"
                @change="search()"
                dense /> -->
            <v-select
                label="事業所会員Ⅰ"
                :items="divosionList"
                dense
                v-model="searchCondition.divIndustry1"
                :rules="[]"
                :readonly="attribute == 1"
                :disabled="loading"
                v-on:change="search()"
            ></v-select>
          </v-col>

          <v-col cols="2">
            <!-- <v-checkbox 
                class="mr-3" label="事業所会員Ⅱ" 
                v-model="searchCondition.divIndustry2" 
                :true-value="1"   :false-value="0"
                :disabled="loading || (searchCondition.attribute != 0)"
                @change="search()"
                dense /> -->
            <v-select
                label="事業所会員Ⅱ"
                :items="divosionList"
                dense
                v-model="searchCondition.divIndustry2"
                :rules="[]"
                :readonly="attribute == 1"
                :disabled="loading"
                v-on:change="search()"
            ></v-select>
          </v-col>
          <v-col cols="2">
            <!-- <v-checkbox 
                class="mr-3" label="事業所会員Ⅲ" 
                v-model="searchCondition.divIndustry3" 
                :true-value="1"   :false-value="0"
                :disabled="loading || (searchCondition.attribute != 0)"
                @change="search()"
                dense /> -->
            <v-select
                label="事業所会員Ⅲ"
                :items="divosionList"
                dense
                v-model="searchCondition.divIndustry3"
                :rules="[]"
                :readonly="attribute == 1"
                :disabled="loading"
                v-on:change="search()"
            ></v-select>
          </v-col>
          <v-col cols="2">
            <!-- <v-checkbox 
                class="mr-3" label="賛助" 
                v-model="searchCondition.divSupporter" 
                :true-value="1"   :false-value="0"
                :disabled="loading || (searchCondition.attribute != 0)"
                @change="search()"
                dense /> -->
            <v-select
                label="賛助"
                :items="divosionList"
                dense
                v-model="searchCondition.divSupporter"
                :rules="[]"
                :readonly="attribute == 1"
                :disabled="loading"
                v-on:change="search()"
            ></v-select>
          </v-col>
          <v-col cols="2">
            <!-- <v-checkbox 
                label="冷事" 
                v-model="searchCondition.divFrozen" 
                :true-value="1"   :false-value="0"
                :disabled="loading || (searchCondition.attribute != 0)"
                @change="search()"
                dense /> -->
            <v-select
                label="冷事"
                :items="divosionList"
                dense
                v-model="searchCondition.divFrozen"
                :rules="[]"
                :readonly="attribute == 1"
                :disabled="loading"
                v-on:change="search()"
            ></v-select>
          </v-col>
        </v-row>
        <!-- </v-layout> -->
        </v-col>

        <v-col v-if="searchCondition.attribute == 1" cols="3">
            <v-select
                :items="associationType"
                dense
                v-model="searchCondition.associationType"
                :rules="[]"
                :readonly="attribute == 1"
                :disabled="loading"
                v-on:change="search()"
              ></v-select>
          </v-col>
      </v-row>

      <v-row v-if="!solo">
        <v-col cols="4">
          <v-autocomplete label="都道府県" 
                v-model="searchCondition.prefIdList" 
                :items="prefList" 
                multiple
                dense 
                :disabled="loading"
                :loading="loading"
                @change="search()"
          ></v-autocomplete>
        </v-col>
        <v-col cols="3">
            <v-text-field
              label="検索"
              v-model="searchCondition.searchString"
              dense
              :readonly="false"
              :clearable="false"
              :rules="[maxLength(50)]"
              :loading="loading"
            ></v-text-field>
        </v-col>
        <v-col cols="5">
          <v-radio-group 
            label="メール送信対象"
            v-model="searchCondition.checkMailSend"
            dense
            row
            :disabled="loading || searchCondition.attribute != 0"
            :readonly="searchCondition.attribute != 0"
            @change="search()"
          >
            <v-radio
              label="全て"
              :value="0"
              checked
            ></v-radio>
            <v-radio
              label="本社"
              :value="1"
            ></v-radio>
            <v-radio
              label="事業所"
              :value="2"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="3">
            <v-text-field
              label="検索"
              v-model="searchCondition.searchString"
              dense
              :readonly="false"
              :clearable="false"
              :rules="[maxLength(50)]"
              :loading="loading"
            ></v-text-field>
        </v-col>
      </v-row>

      <!-- <v-row>
        <v-col cols="3" sm="3" md="3" lg="3">
            <v-text-field
              label="会社名"
              v-model="searchCondition.companyName"
              dense
              :readonly="false"
              :clearable="false"
              :rules="[maxLength(50)]"
              :loading="loading"
            ></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="2" sm="2" md="2" lg="2">
          <v-btn class="btn_font primary" width="120" v-on:click="search()" :disabled="loading" ><v-icon :small="true">mdi-magnify</v-icon>検索</v-btn>
        </v-col>
      </v-row> -->
    </v-form>
    <!-- メールアドレス一覧/選択エリア -->
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-row class="mb-n7">
        <v-col v-if="!solo && !loading" cols="auto">
          <input :disabled="filterItems.length <= 0" type='checkbox' id="select-all-checkbox" v-model="selectAll" /><label for="select-all-checkbox">すべて選択</label>
        </v-col>
        <v-col v-else-if="!solo && loading" cols="auto">
          <input :disabled="true" type='checkbox' :value="false" /><label>すべて選択</label>
        </v-col>
        <v-col v-else cols="auto">
          <v-btn small class="primary" :height="20" :width="100" :disabled="loading" @click="selectClear()">選択クリア</v-btn>
        </v-col>
        <v-col cols="auto">
        {{ filterItemsMemberCnt }}件の会員・協会が見つかりました
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-data-table
            ref="ref"
            :headers="comHeaders"
            :items="emailAddressList"
            :loading="loading"
            :dense='true'
            :items-per-page="10"
            :mobile-breakpoint="0"
            :disable-pagination='true'
            :hide-default-footer='true'
            :fixed-header='true'
            disable-sort
            locale="ja-jp"
            loading-text="読込中"
            no-data-text="データがありません。"
            class="table-border"
            :search="searchCondition.searchString"
            height="calc(100vh - 500px)"
          >
            <template v-slot:item="{ item }">
              <tr :key="item.index">
                <td class="center">
                  <input v-if="!solo" type='checkbox' v-model="innerSelectedList" :value="{memberNo:item.emailMemberNo, email:item.email, toAddress:item.toAddress}" />
                  <input v-else type='radio' v-model="innerSelectedList" :value="{memberNo:item.emailMemberNo, email:item.email, toAddress:item.toAddress}" />
                </td>
                <td class="left">
                  {{item.emailMemberNo}}
                </td>
                <td v-if="searchCondition.attribute == 0" class="left">
                  {{item.companyName}}
                </td>
                <td v-if="searchCondition.attribute == 0" class="left">
                  {{item.memberName}}
                </td>
                <td v-else class="left">
                  {{item.associationName}}
                </td>
                <td class="left">
                  {{item.toAddress}}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <!-- アクション -->
      <v-row>
        <v-col cols="6" sm="6" md="6" lg="6" class="text-center">
          <v-btn class="btn_font primary" width="120" v-on:click="registData()" :disabled="loading" >確定</v-btn>
        </v-col>
        <v-col cols="6" sm="6" md="6" lg="6" class="text-center">
          <v-btn class="btn_font primary" width="120" v-on:click="cancel()" :disabled="loading" >キャンセル</v-btn>
        </v-col>
      </v-row>
    </v-form>

  </v-container>
</template>

<script>
import Debug from '../Lib/Debug'
import Message from "../Lib/Message";
import Const from '../mixins/const';
import Mixin from "../mixins/const.js";

import MUser from "../model/m_user";

export default {
  mixins: [Mixin, Const],
  
  components: {
  },

  props: {
    selectedList: Array,
    type: Number,
    solo: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    valid : true,
    loading: false,

    show: true,

    // 検索条件
    searchCondition: {
      attribute: 0,
      listType: 0,
      divCompany: -1,
      divIndustry1: -1,
      divIndustry2: -1,
      divIndustry3: -1,
      divSupporter: -1,
      divFrozen: -1,
      prefIdList: [],
      searchType: "",
      searchString: "",
      checkMailSend: 0,
      associationType: 0,
    },

    emailAddressList: [],

    // テーブルヘッダー
    headersMember: [
        { text: '選択', align: 'center', sortable: true, value: 'check', width: "5%" },
        { text: '会員ID', align: 'center', sortable: true, value: 'emailMemberNo', width: "10%" },
        { text: '会社名', align: 'center', sortable: true, value: 'companyName', width: "25%" },
        { text: '事業所名', align: 'center', sortable: true, value: 'memberName', width: "30%" },
        { text: '宛先', align: 'center', sortable: true, value: 'toAddress', width: "30%" },
    ],
    headersAssociation: [
        { text: '選択', align: 'center', sortable: true, value: 'check', width: "5%" },
        { text: '会員ID', align: 'center', sortable: true, value: 'emailMemberNo', width: "10%" },
        { text: '協会名', align: 'center', sortable: true, value: 'associationName', width: "25%" },
        { text: '宛先', align: 'center', sortable: true, value: 'toAddress', width: "30%" },
    ],

    innerSelectedList: [],
  }),

  // ライフサイクルフック
  created: function () {
    if(this.solo) {
      // 発信者は日冷倉ユーザのみ
      this.searchCondition.attribute = 2;
    }

    this.loadList();
  },

  mounted: async function () {

  },

  methods: {
    /** 表示更新 */
    async loadList() {
      Debug.log('function[loadList]');
      this.loading = true;

      try {
        const res = await MUser.searchEmailAddress(this.searchCondition);
        Debug.log2('userList:', res.data);
        //if(res.data.length > 0) {
          this.emailAddressList = res.data;
        //}
      } catch (error) {
        Message.err(error, "ユーザ一覧を取得できませんでした");
      }
      Debug.log(this.emailAddressList);

      this.loading = false;
    },

    search() {
      Debug.log("function[search]");
      this.loadList();
    },

    // 選択クリア
    selectClear() {
      Debug.log("function[selectClear]");
      this.innerSelectedList = [];
    },

    /** 確定 */
    registData() {
      Debug.log("function[registData]");
      if (!confirm("確定します。よろしいですか？")) return;

      Debug.log2('innerSelectedList:', this.innerSelectedList);

      // 表示用string
      let tmpStr = "";

      if(this.solo) {
        //if(this.innerSelectedList.length > 0) {
          tmpStr = [this.innerSelectedList].map((selected) => {
            return selected.toAddress;
          }).join(',');
        //}
      } else {
        tmpStr = this.innerSelectedList.map((selected) => {
          return selected.toAddress;
        }).join(',');
      }

      Debug.log(tmpStr);

      // 親画面に値を返す
      this.$emit('registEvt', this.type, this.innerSelectedList, tmpStr);
      this.close();
    },

    // キャンセル
    cancel() {
      if (!confirm("変更をキャンセルします。よろしいですか？")) return;
      this.close();
    },

    close() {
      this.$emit("closeEvt");
    },

    // テーブルヘッダーを変更する
    changeHeader() {
      Debug.log('function[changeHeader]');

      if(this.searchCondition.attribute == 0) {
        // ヘッダーの変更
        return this.headersMember;
      } else {
        // ヘッダーの変更
        return this.headersAssociation;
      }
    },
  },

  computed: {
    comHeaders() {
      return this.changeHeader();
    },

    filterItems() {
      if (this.emailAddressList.length > 0) {
        return this.$refs.ref.$children[0].filteredItems;
      } else {
        return [];
      }
    },

    // 選択リストにフィルターアイテムが含まれている
    isIncludesSelectedList() {
      //this.$nextTick(() => {
        let cnt = 0;
        this.filterItems.forEach(function (item) {
          if(this.innerSelectedList.some(select => select.email === item.email && 
                                                select.memberNo === item.emailMemberNo && 
                                                select.toAddress === item.toAddress)){
            cnt++;
          }
        }.bind(this));

        Debug.log2('this.innerSelectedList:', this.innerSelectedList);
        Debug.log2('this.filterItems:', this.filterItems);
        Debug.log2('isIncludesSelectedList:', cnt);

        return (cnt > 0) && (this.filterItems.length === cnt);
      //});
    },

    selectAll: {
      get: function () {
        Debug.log2('selectAll get:', this.filterItems ? ((this.filterItems.length > 0) && (this.isIncludesSelectedList)) : false);
        //return this.filterItems ? this.filterItems.length > 0 && this.innerSelectedList.length == this.filterItems.length : false;

        return this.filterItems ? ((this.filterItems.length > 0) && (this.isIncludesSelectedList)) : false;
      },
      set: function (id) {
        let tmpSelectedList = [];

        this.filterItems.forEach(function (emailAddressList) {
          tmpSelectedList.push({memberNo:emailAddressList.emailMemberNo, email:emailAddressList.email, toAddress:emailAddressList.toAddress});
        });
        Debug.log2('id',id);
        if (id) {
          // すべて選択の場合
          Debug.log('selectAll set');

          Debug.log2('this.innerSelectedList',this.innerSelectedList);
          Debug.log2('tmpSelectedList',tmpSelectedList);
          //this.innerSelectedList = tmpSelectedList;
          //this.innerSelectedList = Object.assign(this.innerSelectedList, tmpSelectedList);
          //this.innerSelectedList = Array.from(new Set(this.innerSelectedList.concat(tmpSelectedList)));
          let tmpInnerSelectedList = Array.from(new Set(this.innerSelectedList.concat(tmpSelectedList)));
          // this.innerSelectedList = Array.from(
          //   new Map(tmpInnerSelectedList.map((item) => [user.id, user])).values()
          // );
          this.innerSelectedList = tmpInnerSelectedList.filter((element, index, self) => 
                                      self.findIndex(e => 
                                        e.email === element.email &&
                                        e.memberNo === element.memberNo &&
                                        e.toAddress === element.toAddress
                                      ) === index
                                    );
        } else {
          // すべて選択解除の場合
          Debug.log('selectAll false');
          Debug.log2('this.innerSelectedList',this.innerSelectedList);
          Debug.log2('tmpSelectedList',tmpSelectedList);
          let tmpInnerSelectedList = this.innerSelectedList;
          // 表示されているすべてのアイテムを削除
          tmpSelectedList.forEach(function (d) {
            tmpInnerSelectedList = tmpInnerSelectedList.filter(function(b){
                                        return b.email !== d.email && b.memberNo !== d.memberNo && b.toAddress !== d.toAddress
                                      });
            
          });

          this.innerSelectedList = tmpInnerSelectedList;
        }
        
        Debug.log2('this.innerSelectedList',this.innerSelectedList);
      }
    },

    // 検索結果会員・協会件数
    filterItemsMemberCnt() {
      if (this.emailAddressList.length > 0) {
        let tmpItems = this.$refs.ref.$children[0].filteredItems;
        const cntList = Array.from(new Set(tmpItems.map((item) => {
            return item.emailMemberNo;
          })
        ));
        return cntList.length;
      } else {
        return 0;
      }
    },
  },

  watch: {
    selectedList: {
      immediate: true,
      handler(value) {
        if(!this.solo) {
          this.innerSelectedList = value;
        } else {
          this.innerSelectedList = value[0];
        }
      },
    },
  },
};
</script>

<style scoped>
.v-input--radio-group {
  margin: 0;
}

.disablecolor {
  background: #bbbbbb;
}

</style>
